export default theme => ({
  buttonContainer: {
    position: 'absolute',
    borderRadius: '100%',
    zIndex: 10,
    color: theme.palette.common.white,
    right: theme.spacing(2),
    top: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      right: theme.spacing(3),
      top: theme.spacing(3),
    },
    [theme.breakpoints.up('md')]: {
      right: theme.spacing(12),
      top: theme.spacing(8),
    },
    [theme.breakpoints.up('lg')]: {
      right: theme.spacing(18),
      top: theme.spacing(12),
    },
  },
  drawerDeskPaper: {
    height: '100vh',
    backgroundColor: theme.palette.green.main,
    color: theme.palette.green.contrastText,
    justifyContent: 'center',
    position: 'relative',
  },
  drawerClose: {
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      right: theme.spacing(3),
      top: theme.spacing(3),
    },
    [theme.breakpoints.up('md')]: {
      right: theme.spacing(6),
      top: theme.spacing(8),
    },
    [theme.breakpoints.up('lg')]: {
      right: theme.spacing(8),
      top: theme.spacing(12),
    },
    [theme.breakpoints.down('sm')]: {
      width: '45px !important',
    },
  },
  drawerDeskContainer: {
    textAlign: 'center',
  },
  drawerDeskLabel: {
    display: 'inline',
    lineHeight: 1.4,
    verticalAlign: 'middle',
    cursor: 'pointer',
    fontSize: 'calc(1.6vw + 22px)',
    textDecoration: 'none',
    color: theme.palette.green.contrastText,
    fontWeight: 300,
    '&:hover': {
      fontWeight: 700,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
      display: 'block',
    },
  },
  drawerDeskLabelSep: {
    display: 'inline-block',
    verticalAlign: 'middle',
    width: 25,
    height: 2,
    backgroundColor: theme.palette.green.contrastText,
    margin: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      width: 18,
      height: 1,
      margin: `${theme.spacing(1.5)}px auto`,
    },
  },
  drawerResp: {
    display: 'none',
    // [theme.breakpoints.down('sm')]: {
    //   display: 'block',
    // },
  },
  drawerRespPaper: {
    backgroundColor: theme.palette.green.main,
    color: theme.palette.green.contrastText,
  },
  list: {
    width: 250,
  },
  dialogPaper: {
    padding: theme.spacing(5),
    backgroundColor: theme.palette.blue.light,
    color: theme.palette.common.white,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1),
      padding: theme.spacing(2),
      width: `calc(100% - ${theme.spacing(2)}px)`,
    },
  },
  dialogTitle: {
    paddingRight: 0,
  },
  dialogClose: {
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      right: -5,
      top: -10,
      width: '45px !important',
    },
  },
  dialogSep: {
    width: 70,
    height: 4,
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.common.white,
  },
  dialogParagraph: {
    paddingBottom: theme.spacing(4),
  },
  dialogSubTitle: {
    marginBottom: theme.spacing(2),
  },
  dialogName: {
    paddingBottom: theme.spacing(0.5),
  },
});
